/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useState, useEffect } from 'react';

function tryParseJSON(jsonString) {
    try {
        const obj = JSON.parse(jsonString);
        return obj && typeof obj === 'object' ? obj : false;
    } catch (e) {
        return false;
    }
}

function usePersistedState(key, defaultValue) {
    const [state, setState] = useState(
        () => tryParseJSON(localStorage.getItem(key)) || defaultValue,
    );

    useEffect(() => {
        const parseState = typeof state !== 'string' ? JSON.stringify(state) : state;
        localStorage.setItem(key, parseState);
    }, [key, state]);
    return [state, setState];
}

export default usePersistedState;
